import axios, { AxiosError, InternalAxiosRequestConfig } from "axios";
import { useRouterStore } from "../../stores";

export const magnoApi = axios.create({
  baseURL: `https://api-magno.younet.ec`,
  headers: {
    "Content-Type": "application/json",
  },
});

// Marcamos las peticiones reintentadas para no entrar en bucle
interface RetryConfig extends InternalAxiosRequestConfig {
  _retry?: boolean;
}

// Interceptor de respuesta: ante 401, refresca y reintenta UNA vez
magnoApi.interceptors.response.use(
  (res) => res,
  async (error: AxiosError) => {
    const original = error.config as RetryConfig;

    // evita reintentar el propio login/refresh para no hacer bucle
    const esRutaAuth =
      original?.url?.includes("/auth/login") ||
      original?.url?.includes("/auth/refresh");

    // con API key no hay token que renovar: un 401 es una key inválida
    const usaApiKey = !!useRouterStore.getState().apiKeyMagnoSri;

    if (
      error.response?.status === 401 &&
      !original._retry &&
      !esRutaAuth &&
      !usaApiKey
    ) {
      original._retry = true;
      try {
        const { renovarToken } = await import("./auth");
        // ojo: renovarToken no está exportado; ver nota abajo
        const nuevoToken = await renovarToken();
        original.headers.Authorization = `Bearer ${nuevoToken}`;
        return magnoApi(original); // reintenta la petición original
      } catch (err) {
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  },
);
